"use client";

import { useState } from "react";

type Props = {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
};

export default function CollapsibleSection({ title, defaultOpen = false, children }: Props) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="border-t border-border-light pt-4 mt-4">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="group flex min-h-11 w-full items-center gap-2 text-left outline-none focus-visible:ring-2 focus-visible:ring-teal"
        aria-expanded={open}
      >
        <svg
          className={`w-3.5 h-3.5 text-text-muted transition-transform ${open ? "rotate-90" : ""}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
        <span className="text-[13px] font-semibold uppercase tracking-[1px] text-text-muted group-hover:text-navy transition-colors">
          {title}
        </span>
      </button>
      {open && <div className="mt-3">{children}</div>}
    </div>
  );
}
